module.exports = __webpack_public_path__ + "img/upload.fac1ce8c.png";